// extracted by mini-css-extract-plugin
module.exports = {"container":"container--AlertContainer-components__3nZCe"};